import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../../services/api';
import { AuthContext } from '../../../context/AuthContext';

const CheckoutSuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useContext(AuthContext);

  const verifySubscription = async () => {
    const sessionId = searchParams.get('session_id');

    if (!sessionId) {
      setError('Session ID manquant.');
      setLoading(false);
      return;
    }

    try {
      const data = await api.post('/coach/auth/verify-checkout', { sessionId });

      if (data.success && data.token) {
        login(data.token);
        setSubscriptionStatus('active');
      } else {
        setSubscriptionStatus('inactive');
      }
    } catch (err) {
      console.error('Erreur lors de la verification:', err);
      setError(err.message || 'Erreur lors de la verification de l\'abonnement.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verifySubscription();
  }, []);

  // Rediriger vers le profil apres 3 secondes
  useEffect(() => {
    if (subscriptionStatus === 'active' || error) {
      const timer = setTimeout(() => {
        navigate('/coach/profile');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [subscriptionStatus, error, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#fafafa',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          p: 4,
          maxWidth: 400,
        }}
      >
        {loading ? (
          <>
            <CircularProgress size={48} sx={{ mb: 3, color: '#333' }} />
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#333' }}>
              Verification en cours...
            </Typography>
          </>
        ) : error ? (
          <>
            <ErrorOutlineIcon sx={{ fontSize: 56, color: '#d32f2f', mb: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#333', mb: 1 }}>
              Une erreur est survenue
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
              {error}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              onClick={() => navigate('/coach/profile')}
              sx={{ color: '#333', borderColor: '#ccc' }}
            >
              Retour au profil
            </Button>
          </>
        ) : subscriptionStatus === 'active' ? (
          <>
            <CheckCircleIcon sx={{ fontSize: 56, color: '#4caf50', mb: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#333', mb: 1 }}>
              Abonnement active
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              Redirection en cours...
            </Typography>
          </>
        ) : (
          <>
            <ErrorOutlineIcon sx={{ fontSize: 56, color: '#d32f2f', mb: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#333', mb: 1 }}>
              Echec de l'activation
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
              Contactez le support si le probleme persiste.
            </Typography>
            <Button
              variant="outlined"
              size="small"
              onClick={() => navigate('/coach/profile')}
              sx={{ color: '#333', borderColor: '#ccc' }}
            >
              Retour au profil
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default CheckoutSuccessPage;
